import React from 'react';

const AcSwitch = ({ 
  acUnits, 
  onToggle, 
  activeUnits,
  colors = [
    '#06D6A0',   // Green
    '#3B82F6',   // Blue
    '#F43F5E',   // Red
    '#8B5CF6'    // Purple
  ]
}) => {
  return (
    <div className="flex flex-wrap gap-6 justify-center items-center">
      {acUnits.map((ac, index) => (
        <div key={ac} className="flex flex-col items-center">
          <span className="mb-2 text-white font-medium">{ac}</span>
          <div className="relative group">
            <input
              checked={activeUnits.includes(ac)}
              onChange={() => onToggle(ac)}
              className="sr-only"
              id={`switch-${ac}`}
              type="checkbox"
            />
            <label
              style={{
                backgroundColor: activeUnits.includes(ac) 
                  ? colors[index % colors.length] 
                  : 'rgb(156 163 175)' // Tailwind gray-400
              }}
              className="relative flex h-[30px] w-[80px] cursor-pointer items-center justify-between rounded-[100px] transition-all duration-300 ease-in-out shadow-md hover:shadow-lg"
              htmlFor={`switch-${ac}`}
            >
              <span
                className={`
                  absolute 
                  left-[2px] 
                  top-[2px] 
                  h-[25px] 
                  w-[25px] 
                  rounded-full 
                  bg-white 
                  shadow-md 
                  transition-all 
                  duration-300 
                  ease-in-out
                  ${activeUnits.includes(ac) ? 'translate-x-[51px]' : ''}
                  group-hover:scale-105
                  group-active:w-[20px]
                `}
              />
            </label>
          </div>
        </div>
      ))}
    </div>
  );
};

export default AcSwitch;
